import {AfterContentInit, Component, OnInit} from '@angular/core';
import {ExternalEmployeeService} from '../../../services/external-employee.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {StaticMethods} from '../../../model/GeneralModels';

interface TabInfo {
  label: string;
  count: number;
  requestList: any[];
}

@Component({
  selector: 'app-product-home-page',
  templateUrl: './product-home-page.component.html',
  styleUrls: ['./product-home-page.component.css']
})
export class ProductHomePageComponent implements OnInit, AfterContentInit {
  tabList: TabInfo[];
  translation: any = {};
  productName: string;
  constructor(private service: ExternalEmployeeService,
              private activateRoute: ActivatedRoute,
              public settings: AppSettingsService,
              private router: Router) {
  }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.activateRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      this.service.getRequestsCount(this.productName).subscribe(response => {
        if (response.success) {
          this.tabList = [];
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          response.data.tabList.forEach(item => {
            this.tabList.push({
              label: item,
              count: response.data[item],
              requestList: []
            });
          });
          this.getRequests(this.tabList[0].label);
        }
      });
    });
  }

  getRequests(mode: string) {
    this.service.getEmployeeRequests(this.productName, mode).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        const object = this.tabList.find(tab => {
          return tab.label === mode;
        });
        object.requestList = response.data.list;
        object.count = response.data.count;
      }
    });
  }

  printIndex($event: number) {
    console.log($event);
    this.getRequests(this.tabList[$event].label);
  }

  getRequestInfo(row: any) {
    this.router.navigate([`/external-employee/${this.productName}/${row.id}`]);
  }
}
